<template>
  <v-container class="purchase-container">
    <div>
      <h1 class="text-center">用户购买协议</h1>
      <div class="text-right" style="font-size: 16px;">2020年3月</div>
      <p style="text-indent: 2em; font-size: 16px;">
        因用户通过合肥机数有限公司（以下简称“机数”）运营的
        <a href="http://www.dcaiku.com/" target="_blank"
          >http://www.dcaiku.com/</a
        >
        网络平台购买机数提供的搜索服务，双方根据《中华人民共和国协议法》、《中华人民共和国网络安全法》和有关国家法律规定，在平等、自愿、协商一致的基础上，签订本协议，用户在点击同意本协议前，已仔细阅读并完全理解本协议的全部内容，并愿意遵守所有约定。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第一条 用户购买服务内容</h2>
      <div style="text-align: center;" class="all-center">
        <table>
          <tr>
            <td>产品名称</td>
            <td>产品型号</td>
            <td>产品规格</td>
            <td>服务期限</td>
            <td>单价</td>
            <td>数量</td>
            <td>小计</td>
          </tr>
          <tr>
            <td>机数搜索服务</td>
            <td>{{ $i18n.t(`author.${serviceMsg.subject}`) }}</td>
            <td>详情见"套餐及价格"页面介绍</td>
            <td v-if="serviceMsg.auth !== 60">{{ serviceMsg.auth }}年</td>
            <td v-else>终身</td>
            <td>￥{{ serviceMsg.price }}</td>
            <td>{{ serviceMsg.time }}</td>
            <td>￥{{ serviceMsg.price * serviceMsg.time }}</td>
          </tr>

          <tr>
            <td colspan="7" style="text-align: left;">
              总计: ￥ {{ serviceMsg.price * serviceMsg.time }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第二条 付款方式及服务开通</h2>
      <p style="text-indent: 2em;">
        用户可使用支付宝付款，用户点击同意本协议后点击“确认支付”，通过扫描平台生成的二维码付款，付款成功并经平台确认后，服务即可开通。用户如需提供发票请在“个人中心>订单管理>开具发票”填写相关信息并开具发票。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第三条 功能说明及售后服务</h2>
      <p style="text-indent: 2em;">
        本服务能够实现用户对分子、晶体、化学反应的搜索，机数基于自己所拥有的数据，向用户提供搜索服务。在本协议有效期内，软件服务账户出现使用问题，机数在接到故障通知后24小时内做出明确响应和安排。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第四条 用户权利义务</h2>
      <p style="text-indent: 2em;">
        4.1用户在同一时间，同一个账号下，只能在一台终端使用机数的服务。
      </p>
      <p style="text-indent: 2em;">
        4.2用户应当按照国家网络实名制的强制要求提供真实、准确的用户及使用人信息，账号仅限用户使用，不可转让给协议外的第三方或授权任何第三方使用。
      </p>
      <p style="text-indent: 2em;">
        4.3用户承诺，对于任何含有来自机数的软件、产品及服务、资料以及信息，不得进行非法复制、借用、销售或散发；不得对其进行任何反向工程、解码、反编译。若机数发现用户进行上述行为的，有权立即终止本协议，并追究用户的法律责任。
      </p>
      <p style="text-indent: 2em;">
        4.4用户理解并同意，本软件服务可能会受多种因素影响（包括但不限于用户自身原因、网络服务质量、社会环境等）；也可能会受各种安全问题的侵扰（包括但不限于他人非法利用用户资料；用户下载安装的其他软件或访问网站中含有病毒、木马程序或其他恶意程序，威胁用户的计算机信息和数据的安全，继而影响本服务的正常使用等）。因此，用户应加强信息安全及信息的保护意识，注意对账号和密码的保护，以免遭受损失。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第五条 机数权利义务</h2>
      <p style="text-indent: 2em;">
        5.1机数按照国家相关法律法规的规定，保护用户信息，未经用户同意，机数不向任何公司、组织和个人披露用户的信息和搜索信息，但法律法规另有规定的除外。
      </p>
      <p style="text-indent: 2em;">
        5.2为了增进用户体验，完善服务内容，保证服务的安全性和功能的一致性，机数应当积极开发新的软件功能，并在本协议有效期内为用户提供软件静更新服务（这些更新可能会采取软件替换、修正、功能强化、版本升级等形式）。
      </p>
      <p style="text-indent: 2em;">
        5.3机数承诺，本协议项下软件更新属于免费服务，但软件更新后如有新增付费功能模块，用户需另行付费方可使用。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第六条 免责及特殊条款</h2>
      <p style="text-indent: 2em;">
        6.1在电信网络基础运营商的网络接入发生故障，系统例行的中止维护、用户工作人员操作不当等原因造成的服务工作不正常，机数可免除违约及赔偿责任。
      </p>
      <p style="text-indent: 2em;">
        6.2在中华人民共和国允许的最大限度内，任何情形下，机数或其第三方供应商都不对任何后果性、特别、附带、偶然及间接损害（包括但不限于商业利润损失、业务中断、商业信息损失、购买替代产品或服务、其它金钱损失等损害）负责。任何情形下，对于起于或关于本协议的索赔，机数的最大累积责任限于用户实际支付的协议款总额。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第七条 保密信息的保护</h2>
      <p style="text-indent: 2em;">
        不论在本协议有效期内,还是本协议终止后，任何一方应按照国家有关法律法规的规定，采取安全有效的措施保护另一方的商业和技术秘密，任何一方都不得向第三方透露因签订和执行本协议过程中所获得的另一方的任何机密，除非该披露为国家相关法律法规或命令所要求。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第八条 违约责任</h2>
      <p style="text-indent: 2em;">
        8.1如用户违反本协议规定的付款义务，在用户完成付款义务前，机数有权拒绝用户继续使用软件或提供后续服务。用户逾期付款超过15日的，机数有权单方解除本协议。
      </p>
      <p style="text-indent: 2em;">
        8.2用户如有发生其他本协议内未列出，但属于非法使用的行为，则机数有权终止用户使用软件，给机数造成损失，用户应予以赔偿。
      </p>
      <p style="text-indent: 2em;">
        8.3由于机数发生违反本协议的行为，给用户造成损失的，用户有权要求机数进行经济赔偿，但所有违约和赔偿金额不超过本协议规定的协议总额。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第九条 不可抗拒力</h2>
      <p style="text-indent: 2em;">
        如下情况是因不可抗拒力而导致协议无法正常执行时，甲乙双方都将不承担违约责任：
      </p>
      <p style="text-indent: 2em;">
        9.2由于战争、地震、火灾、水灾、台风及一切不可抗拒的自然灾害，由于罢工、政府或军事机关的行动、流行病、动乱、网络非法攻击等不能预见且对其发生和后果不能避免的不可抗拒事故,造成本协议不能正常履行。
      </p>
      <p style="text-indent: 2em;">
        9.3由于电信部门的通信线路事故、维护、破损、中断,或供电部门停电，及其他因邮电、电力部门的原因导致的信号中断；由于国际光缆线路、国际Internet主干网、国际合作伙伴网络的原因而导致的信号中断。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第十条 纠纷解决</h2>
      <p style="text-indent: 2em;">
        凡由本协议引起的与解释或执行本协议相关的争议，双方应协商解决，协商不成的，任何一方均可向有管辖权的人民法院起诉。
      </p>
    </div>
    <div>
      <h2 style="text-indent: 2em;">第十一条 其他</h2>
      <p style="text-indent: 2em;">
        11.1双方可协商一致对本协议进行修改或补充，任何对本协议的修改和补充需采用书面补充协议形式，补充协议与本协议具有同等法律效力。
      </p>
      <p style="text-indent: 2em;">11.2本协议经过用户线上点击确认后生效。</p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "purchaseAgreement",
  data() {
    return {
      serviceMsg: {},
    };
  },
  mounted() {
    this.serviceMsg = JSON.parse(window.localStorage.getItem("serviceMsg"));
    console.log(this.serviceMsg);
  },
};
</script>

<style lang="scss">
.purchase-container {
  div {
    h2 {
      padding: 10px 0;
    }
  }

  p {
    font-size: 16px;
  }

  table {
    border-collapse: collapse;
    border: 2px solid rgb(200, 200, 200);
    letter-spacing: 1px;
    font-size: 0.8rem;
  }

  td,
  th {
    border: 1px solid rgb(190, 190, 190);
    padding: 10px 20px;
  }

  th {
    background-color: rgb(235, 235, 235);
  }

  td {
    text-align: center;
  }

  tr:nth-child(even) td {
    background-color: rgb(250, 250, 250);
  }

  tr:nth-child(odd) td {
    background-color: rgb(245, 245, 245);
  }

  caption {
    padding: 10px;
  }
}
</style>
